<template>
  <b-card class="mx-auto activation-card" style="max-width: 640px; margin: 50px">
    <div v-if="isLoading" class="text-center">
      <b-icon icon="hourglass-split" class="mb-3 activation-icon" />
      <h3 class="mb-2">Activation en cours...</h3>
      <p class="text-muted mb-0">Veuillez patienter pendant la validation de votre compte.</p>
    </div>

    <div v-else-if="isSuccess" class="text-center">
      <b-icon icon="check-circle-fill" class="mb-3 activation-icon activation-icon-success" />
      <h3 class="mb-2">Compte activé</h3>
      <p class="mb-2">Votre compte est maintenant actif. Vous pouvez vous connecter.</p>
      <p class="text-muted mb-0">Redirection vers l'accueil...</p>
    </div>

    <div v-else class="text-center">
      <b-icon icon="x-circle-fill" class="mb-3 activation-icon activation-icon-error" />
      <h3 class="mb-2">Activation impossible</h3>
      <p class="mb-2">{{ errorMessage }}</p>
      <p class="text-muted mb-0">Vérifiez le lien d'activation reçu par e-mail.</p>
    </div>
  </b-card>
</template>

<script>
import UserService from "@/services/user.service";

export default {
  name: "EmailActivation",
  data() {
    return {
      isLoading: true,
      isSuccess: false,
      errorMessage: null
    };
  },
  async mounted() {
    const code = this.$route.query.code;

    if (!code || typeof code !== "string") {
      this.isLoading = false;
      this.errorMessage = "Code d'activation invalide.";
      return;
    }

    try {
      const res = await UserService.activateAccount(code);
      const data = res.data;

      if (res.status === 200 && data.success === true) {
        this.isSuccess = true;
        setTimeout(() => {
          this.$router.push({ path: "/", query: { login: "required" } });
        }, 5000);
      } else {
        this.errorMessage = "Code d'activation invalide ou expiré.";
      }
    } catch (error) {
      this.errorMessage = error.message || "Erreur lors de l'activation du compte.";
    } finally {
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.activation-card {
  border: 1px solid #e5e7eb;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.activation-icon {
  font-size: 2.2rem;
  color: #6b7280;
}

.activation-icon-success {
  color: #2f855a;
}

.activation-icon-error {
  color: #c53030;
}
</style>
